@if (visible()) {
	<div class="jobs-overlay" (click)="onVisibleChange(false)">
		<div class="jobs-slide-panel" (click)="$event.stopPropagation()">
			<div class="flex items-center justify-between px-4 py-3">
				<span class="text-sm font-bold text-wb-accent uppercase tracking-wider">Generation Jobs</span>
				<button class="text-wb-muted hover:text-wb-text transition-colors bg-transparent border-0 cursor-pointer" (click)="onVisibleChange(false)">
					<i class="pi pi-times"></i>
				</button>
			</div>

			<!-- Filter tabs -->
			<div class="filter-tabs">
				@for (f of filters; track f.key) {
					<button
						class="filter-tab"
						[class.active]="filter() === f.key"
						(click)="filter.set(f.key)"
					>
						{{ f.label }}
						<span class="filter-count">{{ counts()[f.key] }}</span>
					</button>
				}
			</div>

			<!-- Jobs list -->
			<div class="jobs-list">
				@for (job of filteredJobs(); track job.jobId) {
					<div class="job-row" [class.job-row--active]="isActive(job)">
						<div class="job-icon">
							@switch (job.status) {
								@case ('running') { <i class="pi pi-spin pi-spinner text-wb-accent-2"></i> }
								@case ('pending') { <i class="pi pi-clock text-wb-muted"></i> }
								@case ('done') { <i class="pi pi-check-circle text-wb-success"></i> }
								@case ('error') { <i class="pi pi-exclamation-circle text-wb-danger"></i> }
							}
						</div>

						<div class="job-main">
							<div class="job-header">
								<span class="job-name" [title]="job.mediaName">{{ job.mediaName }}</span>
								<span class="job-type">{{ job.type }}</span>
							</div>

							@if (isVariantGroupJob(job)) {
								<!-- Variant groups: one aggregate bar. Hides per-variant currentStep
										 and version count to avoid "Transcoding ChannelA to AAC" x 40. -->
								@if (isActive(job)) {
									<div class="job-progress">
										<div class="progress-bar">
											<div class="progress-fill" [style.width.%]="progressPercent(job)"></div>
										</div>
										<span class="job-step">{{ progressPercent(job) }}%</span>
									</div>
								} @else if (job.status === 'error') {
									<div class="job-error">{{ job.error ?? 'Failed' }}</div>
								} @else if (job.status === 'done') {
									<div class="job-done">Variant generation complete</div>
									@if (job.errorMessages; as errs) {
										@if (errs.length) {
											<div class="job-warning">{{ errs.length }} item(s) failed — {{ errs[0] }}</div>
										}
									}
								}
							} @else if (isActive(job)) {
								<div class="job-progress">
									<div class="progress-bar">
										<div class="progress-fill" [style.width.%]="progressPercent(job)"></div>
									</div>
									<span class="job-step">{{ job.currentStep }}</span>
								</div>
							} @else if (job.status === 'error') {
								<div class="job-error">{{ job.error ?? 'Failed' }}</div>
							} @else if (job.status === 'done') {
								<div class="job-done">
									@if (isThumbnailJob(job)) {
										Thumbnail generated
									} @else {
										{{ job.completedVersions.length }} version(s) generated
									}
								</div>
								@if (job.errorMessages; as errs) {
									@if (errs.length) {
										<div class="job-warning">{{ errs.length }} item(s) failed — {{ errs[0] }}</div>
									}
								}
							}
						</div>

						<div class="job-meta">
							<span class="job-time">{{ job.createdAt | date:'short' }}</span>
							@if (isActive(job)) {
								<button class="job-dismiss job-dismiss--cancel" (click)="cancelJob(job.jobId)" title="Cancel job">
									<i class="pi pi-stop" style="font-size: 9px;"></i>
								</button>
							} @else {
								<button class="job-dismiss" (click)="dismissJob(job.jobId)" title="Dismiss">
									<i class="pi pi-times" style="font-size: 9px;"></i>
								</button>
							}
						</div>
					</div>
				}

				@if (filteredJobs().length === 0) {
					<div class="empty-state">
						No {{ filter() === 'all' ? '' : filter() }} jobs
					</div>
				}
			</div>
		</div>
	</div>
}
